module.exports = __webpack_public_path__ + "static/media/chevronLeftDouble.7dcf4f48.svg";